"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDocsApi = exports.ENVS_MAPPINGS = void 0;
var _docsJsSdk = require("@adsk/docs-js-sdk");
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
const ENVS_MAPPINGS = exports.ENVS_MAPPINGS = {
  [_acsScWebPlatformApi.ENVS.QA]: _docsJsSdk.DOCS_ENVS.QA,
  [_acsScWebPlatformApi.ENVS.STAGING]: _docsJsSdk.DOCS_ENVS.STAGING,
  [_acsScWebPlatformApi.ENVS.PRODUCTION]: _docsJsSdk.DOCS_ENVS.PRODUCTION
};
let docsSDK;
const getDocsApi = () => {
  if (!docsSDK) {
    const options = {
      region: (0, _acsScWebPlatformApi.getRegion)(),
      // fallback should be doc qa env
      env: ENVS_MAPPINGS[(0, _acsScWebPlatformApi.getEnv)()] || _docsJsSdk.DOCS_ENVS.QA,
      getToken: _acsScWebPlatformApi.getCurrentToken
    };
    // @ts-ignore
    _docsJsSdk.Docs.init(options); // TODO: Something's wrong with typings here
    docsSDK = _docsJsSdk.Docs;
  }
  return docsSDK;
};
exports.getDocsApi = getDocsApi;
//# sourceMappingURL=DocsApi.js.map